import { useAppData } from "./App.tsx";
import { GageLogo } from "./GageLogo.tsx";
import { WelcomeForm } from "./WelcomeForm.tsx";


export function Welcome() {
  const appData = useAppData();

  return <div class="welcome">
    <div class="center">
      <GageLogo height={25} />
      <h1>Welcome to Gage Ignite, {appData.user.value?.name}</h1>
      <p>Ignite has several new features including a sales campaign creator, a briefer that gives you strategic insights on your customers and leads, and a tool to help learn AI. We will be learning about these features together in the coming weeks, but feel free to try them now after you log in!</p>
      <WelcomeForm />
    </div>
  </div>
}